<template>
  <div class="admin-page-footer-box">
    <el-pagination
      :small="small"
      :background="background"
      :page-size="pageSize"
      :total="total"
      :page-count="pageCount"
      :pager-count="pagerCount"
      :current-page="currentPage"
      :layout="layout"
      :page-sizes="pageSizes"
      :disabled="disable"
      :hide-on-single-page="hideOnSinglePage"

      @size-change="onSizeChange"
      @current-change="onCurrentChange"
      @prev-click="onPrevClick"
      @next-click="onNextClick"
    >
    </el-pagination>
  </div>
</template>

<script>
export default {
  name: 'PageFooter',
  methods: {
    onSizeChange (pageSize) {
      this.$emit('size-change', pageSize)
    },
    onCurrentChange (currentPage) {
      this.$emit('current-change', currentPage)
    },
    onPrevClick (currentPage) {
      this.$emit('prev-click', currentPage)
    },
    onNextClick (currentPage) {
      this.$emit('next-click', currentPage)
    }
  },
  props: {
    small: {
      type: Boolean,
      default: false
    },
    background: {
      type: Boolean,
      default: true
    },
    pageSize: {
      type: Number,
      default: 15
    },
    total: Number,
    pageCount: Number,
    pagerCount: {
      type: Number,
      default: 7
    },
    currentPage: {
      type: Number,
      default: 1
    },
    layout: {
      type: String,
      default: 'prev, pager, next, sizes,jumper, ->, total'
    },
    pageSizes: {
      type: Array,
      default: function () {
        return [10, 15, 20, 30, 50, 100]
      }
    },
    disable: {
      type: Boolean,
      default: false
    },
    hideOnSinglePage: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
  .admin-page-footer-box{
    width: 100%;
    max-height: 38px;
  }
</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/components/Pages/PageFooter.vue"
}
</vue-filename-injector>
